window.playQuizQuestions = {
  hunde: [
  {
    question: "Wie viele Zähne hat ein ausgewachsener Hund normalerweise?",
    answer: "42"
  },
  {
    question: "Welche Hunderasse ist für ihre blaue bis schwarze Zunge bekannt?",
    answer: "Chow-Chow"
  },
  {
    question: "Welche Hunderasse wurde ursprünglich zur Jagd auf Dachse gezüchtet?",
    answer: "Dackel"
  },
  {
    question: "Wie viele Zehen hat ein Hund normalerweise an den Vorderpfoten?",
    answer: "5"
  },
  {
    question: "Wie viele Zehen hat ein Hund normalerweise an den Hinterpfoten?",
    answer: "4"
  },
  {
    question: "Wie nennt man die zusätzlichen Krallen weiter oben am Bein eines Hundes?",
    answer: "Wolfskrallen"
  },
  {
    question: "Welches Organ nutzt ein Hund neben der Nase besonders zur Regulierung seiner Körpertemperatur?",
    answer: "Die Zunge"
  },
  {
    question: "Welche Hunderasse wurde traditionell als Rettungshund in den Alpen eingesetzt?",
    answer: "Bernhardiner"
  },
  {
    question: "Welche Hunderasse trägt denselben Namen wie eine mexikanische Stadt und einen mexikanischen Bundesstaat?",
    answer: "Chihuahua"
  },
  {
    question: "Welches Lebensmittel kann für Hunde wegen des enthaltenen Theobromins gefährlich sein?",
    answer: "Schokolade"
  },
  {
    question: "Welche Hunderasse wurde ursprünglich für die Jagd auf Löwen in Afrika gezüchtet?",
    answer: "Rhodesian Ridgeback"
  },
  {
    question: "Welches auffällige Fellmerkmal gibt dem Rhodesian Ridgeback seinen Namen?",
    answer: "Ein Fellstreifen auf dem Rücken, der entgegen der übrigen Fellrichtung wächst."
  },
  {
    question: "Welche beiden Farbbereiche können Hunde besonders gut unterscheiden?",
    answer: "Blau und Gelb"
  },
  {
    question: "Welches Vitamin können Hunde – anders als Menschen – normalerweise selbst im Körper bilden?",
    answer: "Vitamin C"
  },
  {
    question: "Wie hoch ist die normale Körpertemperatur eines erwachsenen Hundes ungefähr?",
    answer: "Etwa 38–39 °C"
  },
  {
    question: "An welchen Körperstellen besitzen Hunde Schweißdrüsen, die unter anderem der Kühlung dienen können?",
    answer: "Vor allem an den Pfotenballen"
  },
  {
    question: "Was bezeichnet man beim Hund als Widerrist?",
    answer: "Den höchsten Bereich des Rückens am Übergang von Hals und Schulter."
  },
  {
    question: "Bei welcher Hundesportart folgt der Hund einer menschlichen Geruchsspur über längere Strecken?",
    answer: "Mantrailing"
  },
  {
    question: "Wie heißt der Hundesport, bei dem Hund und Mensch gemeinsam laufen und über eine Zugleine verbunden sind?",
    answer: "Canicross"
  },
  {
    question: "Was unterscheidet Hoopers besonders von klassischem Agility?",
    answer: "Der Hund muss keine Sprünge absolvieren."
  },
  {
    question: "Wie heißt der Hundesport, bei dem Hund und Mensch festgelegte Gehorsamsübungen an verschiedenen Stationen absolvieren?",
    answer: "Rally Obedience"
  },
  {
    question: "Wie viele Augenlider hat ein Hund pro Auge?",
    answer: "Drei, einschließlich der Nickhaut"
  },
  {
    question: "Was muss ein Hund beim Longieren im Hundesport hauptsächlich tun?",
    answer: "Auf Distanz um einen abgesteckten Kreis laufen und auf Signale reagieren."
  },
  {
    question: "Warum ist die Hundenase häufig feucht?",
    answer: "Feuchtigkeit hilft dabei, Duftmoleküle aufzunehmen."
  },
  {
    question: "Nach ungefähr wie vielen Tagen öffnen Welpen normalerweise ihre Augen?",
    answer: "Nach etwa 10–14 Tagen"
  },
  {
    question: "Welchen Geschmack können Hunde – anders als Katzen – wahrnehmen?",
    answer: "Süß"
  },
  {
    question: "Wofür wurde der Pudel ursprünglich gezüchtet?",
    answer: "Als Wasserjagd- und Apportierhund"
  },
  {
    question: "In welche Himmelsrichtung richten sich Hunde beim Urinieren oder Kotabsatz unter bestimmten ruhigen Magnetfeldbedingungen laut einer Studie bevorzugt aus?",
    answer: "Entlang der Nord-Süd-Achse"
  },
  {
    question: "Welche Hunderasse ist dafür bekannt, statt typischem Bellen einen jodelähnlichen Laut zu erzeugen?",
    answer: "Basenji"
  },
  {
    question: "Welche Hunderasse kann auf längeren Strecken schneller sein als ein Gepard?",
    answer: "Greyhound"
  }
],

 allgemeinwissen: [
  {
    question: "Welcher Planet ist der Sonne am nächsten?",
    answer: "Merkur"
  },
  {
    question: "Wie viele Bundesländer hat Deutschland?",
    answer: "16"
  },
  {
    question: "Wie heißt die Hauptstadt von Australien?",
    answer: "Canberra"
  },
  {
    question: "Welcher Ozean ist der größte der Erde?",
    answer: "Pazifischer Ozean"
  },
  {
    question: "Wie viele Seiten hat ein Hexagon?",
    answer: "6"
  },
  {
    question: "Welches chemische Element hat das Symbol „Au“?",
    answer: "Gold"
  },
  {
    question: "Wie viele Knochen hat ein erwachsener Mensch ungefähr?",
    answer: "206"
  },
  {
    question: "Wie heißt die größte Wüste der Erde?",
    answer: "Antarktis"
  },
  {
    question: "Wie viele Nullen hat eine Milliarde?",
    answer: "9"
  },
  {
    question: "Wie viele Herzen hat ein Oktopus?",
    answer: "3"
  },
  {
    question: "Welches Tier besitzt den höchsten Blutdruck unter den Landtieren?",
    answer: "Giraffe"
  },
  {
    question: "Wie heißt die meistgesprochene Sprache in Südamerika?",
    answer: "Portugiesisch"
  },
  {
    question: "Wie viele Planeten unseres Sonnensystems haben Ringe?",
    answer: "4"
  },
  {
    question: "Welches Land hat als einziges eine nicht rechteckige Nationalflagge?",
    answer: "Nepal"
  },
  {
    question: "Wie viele Liter Blut hat ein erwachsener Mensch ungefähr im Körper?",
    answer: "Etwa 5–6 Liter"
  },
  {
    question: "Welches Tier besitzt rechteckige Pupillen?",
    answer: "Ziege"
  },
  {
    question: "Welche Farbe hat die Haut eines Eisbären unter seinem Fell?",
    answer: "Schwarz"
  },
  {
    question: "Wie viele Ringe befinden sich auf der olympischen Flagge?",
    answer: "5"
  },
  {
    question: "In welchem Jahr fiel die Berliner Mauer?",
    answer: "1989"
  },
  {
    question: "Welche römische Zahl steht für 50?",
    answer: "L"
  }
],

 geographie: [
  {
    question: "Welcher Kontinent ist flächenmäßig der größte?",
    answer: "Asien"
  },
  {
    question: "Wie heißt die Hauptstadt von Kanada?",
    answer: "Ottawa"
  },
  {
    question: "Welches Land hat die meisten Einwohner Afrikas?",
    answer: "Nigeria"
  },
  {
    question: "Durch welche Hauptstadt fließt die Seine?",
    answer: "Paris"
  },
  {
    question: "Welches ist das flächenmäßig größte Land der Erde?",
    answer: "Russland"
  },
  {
    question: "Wie heißt die Hauptstadt von Neuseeland?",
    answer: "Wellington"
  },
  {
    question: "Welches Gebirge trennt Frankreich und Spanien?",
    answer: "Pyrenäen"
  },
  {
    question: "In welchem Land liegt die Stadt Marrakesch?",
    answer: "Marokko"
  },
  {
    question: "Welcher Fluss fließt durch Budapest?",
    answer: "Donau"
  },
  {
    question: "Welches Land wird wegen seiner Form oft mit einem Stiefel verglichen?",
    answer: "Italien"
  },
  {
    question: "Wie heißt die Hauptstadt von Island?",
    answer: "Reykjavík"
  },
  {
    question: "Welches Meer liegt zwischen Europa und Afrika?",
    answer: "Mittelmeer"
  },
  {
    question: "Zu welchem Land gehören die Kanarischen Inseln?",
    answer: "Spanien"
  },
  {
    question: "In welchem Land liegt Machu Picchu?",
    answer: "Peru"
  },
  {
    question: "Welcher US-Bundesstaat liegt als Inselgruppe mitten im Pazifik?",
    answer: "Hawaii"
  },
  {
    question: "Wie heißt die Hauptstadt von Portugal?",
    answer: "Lissabon"
  },
  {
    question: "Welches Land grenzt sowohl an Deutschland als auch an Italien?",
    answer: "Österreich"
  },
  {
    question: "Auf welchem Kontinent liegt die Atacama-Wüste?",
    answer: "Südamerika"
  },
  {
    question: "Welche zwei Länder teilen sich die Iberische Halbinsel hauptsächlich?",
    answer: "Spanien und Portugal"
  },
  {
    question: "Welches Land hat die längste Küstenlinie der Welt?",
    answer: "Kanada"
  }
],

 natur: [

  {
    question: "Welches ist das schnellste Landtier der Welt?",
    answer: "Der Gepard"
  },
  {
    question: "Wie nennt man den Vorgang, bei dem Pflanzen Lichtenergie in chemische Energie umwandeln?",
    answer: "Photosynthese"
  },
  {
    question: "Welches Säugetier kann als einziges aktiv fliegen?",
    answer: "Die Fledermaus"
  },
  {
    question: "Wie viele Beine hat eine Spinne?",
    answer: "8"
  },
  {
    question: "Wie nennt man den Übergang einer Raupe zum Schmetterling?",
    answer: "Metamorphose"
  },
  {
    question: "Welches Tier ist das größte heute lebende Landtier?",
    answer: "Der Afrikanische Elefant"
  },
  {
    question: "Welches Gas nehmen Pflanzen hauptsächlich aus der Luft auf?",
    answer: "Kohlenstoffdioxid (CO₂)"
  },
  {
    question: "Wie viele Arme hat ein Oktopus?",
    answer: "8"
  },
  {
    question: "Welches Tier legt die größten Eier aller heute lebenden Tiere?",
    answer: "Der Strauß"
  },

  {
    question: "Wie nennt man Tiere, die sowohl Pflanzen als auch Fleisch fressen?",
    answer: "Allesfresser"
  },
  {
    question: "Welches Tier verbringt den größten Teil seines Lebens kopfüber und bewegt sich besonders langsam?",
    answer: "Das Faultier"
  },

  {
    question: "Welches Tier ist für seine Fähigkeit bekannt, verlorene Arme nachwachsen zu lassen?",
    answer: "Der Seestern"
  },

],

  film: [
    {
    question: "Welcher Regisseur drehte die Filme Inception, Interstellar und Oppenheimer?",
    answer: "Christopher Nolan"
  },
  {
    question: "Welcher Film gewann 2020 als erster nicht englischsprachiger Film den Oscar als Bester Film?",
    answer: "Parasite"
  },
  {
    question: "Wie heißt das fiktive Metall, aus dem Captain Americas Schild hauptsächlich besteht?",
    answer: "Vibranium"
  },
  {
    question: "Welcher Schauspieler spielte den Joker in The Dark Knight?",
    answer: "Heath Ledger"
  },
  {
    question: "Wie heißt die Familie, um die sich die Serie Succession hauptsächlich dreht?",
    answer: "Familie Roy"
  },
  {
    question: "Welcher Regisseur führte bei Pulp Fiction Regie?",
    answer: "Quentin Tarantino"
  },
  {
    question: "Wie heißt das Raumschiff von Han Solo in Star Wars?",
    answer: "Millennium Falke"
  },
  {
    question: "Welche Schauspielerin spielt Wednesday Addams in der Netflix-Serie Wednesday?",
    answer: "Jenna Ortega"
  },
  {
    question: "Wie heißt Walter Whites Alter Ego in Breaking Bad?",
    answer: "Heisenberg"
  },
  {
    question: "Welcher Schauspieler verkörperte Iron Man im Marvel Cinematic Universe?",
    answer: "Robert Downey Jr."
  },
  {
    question: "Wie heißt das Hotel in Stanley Kubricks Film The Shining?",
    answer: "Overlook Hotel"
  },
  {
    question: "Welcher Film von Christopher Nolan erzählt die Geschichte des Physikers J. Robert Oppenheimer?",
    answer: "Oppenheimer"
  },
  {
    question: "Wie heißt die fiktive Stadt, in der Batman hauptsächlich Verbrechen bekämpft?",
    answer: "Gotham City"
  },
  {
    question: "Welche Schauspielerin spielte Katniss Everdeen in Die Tribute von Panem?",
    answer: "Jennifer Lawrence"
  },
  {
    question: "Wie heißt der Kontinent, auf dem ein Großteil von Game of Thrones spielt?",
    answer: "Westeros"
  },
  {
    question: "Welcher Schauspieler spielte Hannibal Lecter in Das Schweigen der Lämmer?",
    answer: "Anthony Hopkins"
  },
  {
    question: "Wie heißt der erste abendfüllende Animationsfilm von Disney?",
    answer: "Schneewittchen und die sieben Zwerge"
  }
  ],

  sport: [
   {
    question: "Wie viele Grand-Slam-Turniere gibt es im Tennis pro Jahr?",
    answer: "4"
  },
  {
    question: "Welche Farbe trägt der Gesamtführende der Tour de France?",
    answer: "Gelb"
  },
  {
    question: "Wie lang ist ein Marathon offiziell?",
    answer: "42,195 Kilometer"
  },
  {
    question: "In welcher Sportart wird um den Stanley Cup gespielt?",
    answer: "Eishockey"
  },
  {
    question: "Welcher Boxer trug den Spitznamen „The Greatest“?",
    answer: "Muhammad Ali"
  },
  {
    question: "Wie viele Punkte ist ein Touchdown im American Football wert?",
    answer: "6"
  },
  {
    question: "Welches Land gewann die erste Fußball-Weltmeisterschaft im Jahr 1930?",
    answer: "Uruguay"
  },
  {
    question: "Wie heißt der Bereich im Darts, der die Punktzahl eines Feldes verdreifacht?",
    answer: "Triple"
  },
  {
    question: "Welche drei Disziplinen gehören zu einem klassischen Triathlon?",
    answer: "Schwimmen, Radfahren und Laufen"
  },
  {
    question: "In welcher Sportart bezeichnet man einen Spielstand von 40:40 als Einstand?",
    answer: "Tennis"
  },
  {
    question: "In welcher Sportart werden die Positionen Point Guard und Center verwendet?",
    answer: "Basketball"
  },
  {
    question: "Welches Land ist Rekordweltmeister im Männerfußball?",
    answer: "Brasilien"
  },
  {
    question: "In welcher Sportart wird der Begriff „Ippon“ verwendet?",
    answer: "Judo"
  },
  {
    question: "Wie nennt man im Golf ein Ergebnis von einem Schlag unter Par an einem Loch?",
    answer: "Birdie"
  },
  {
    question: "Wie viele Spieler einer Volleyballmannschaft stehen gleichzeitig auf dem Feld?",
    answer: "6"
  },
  {
    question: "Welche Nation führt bei den Olympischen Sommerspielen historisch den Medaillenspiegel an?",
    answer: "USA"
  }
  ]
};